module.exports = __webpack_public_path__ + "static/media/compress-arrows-alt.813c61ce.svg";